module.exports = __webpack_public_path__ + "img/2025special_03.c66a7b13.jpg";